require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-calculators-im-retired-how-long-will-my-savings-last.json") })
        }
      }, "path---es-calculators-im-retired-how-long-will-my-savings-last");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-calculators-im-retired-how-long-will-my-savings-last!./.cache/json/es-calculators-im-retired-how-long-will-my-savings-last.json
// module id = 2524
// module chunks = 231608221292675